/* eslint-disable no-undef */
import React from "react";
import moment from "moment";
import nofileSvg from '../../../../public/nofile.svg';
import announcementSvg from '../../../../public/announcements-ico.svg';
import { showLoading } from 'react-global-loading';
import ToastService from '../../../../services/ToastService';
import MasterService from '../../../../services/MasterService';
import AnnouncementService from '../../../../services/AnnouncementService';
const today = new Date();
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class AddAnnouncements extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      announceTitle: '',
      announceDesc: '',
      selectedCountry: '',
      imageApi: '',
      categories: [],
      countries: [],
      selectedCategory: [],
      announceDateStart: '',
      announceDateEnd: ''
    };
  }

  componentDidMount = () => {
    this.getCategories();
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) return;

        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };

  handleCategories = (status, catId) => {
    if (status === true) {
      this.setState({
        selectedCategory: [...this.state.selectedCategory, catId]
      });
    }
    else {

      this.setState({ selectedCategory: this.state.selectedCategory.filter((item) => (item !== catId)) });
    }
  };

  onImageSelection = (event) => {
    this.setState({
      selectedImages: [{
        original: URL.createObjectURL(event.target.files[0]),
        thumbnail: URL.createObjectURL(event.target.files[0]),
      }],
      imageApi: event.target.files[0]// [...this.state.imageApi, event.target.files[0]]
    });

  };

  onAnnouncementCreateUpdate = () => {
    showLoading(true);
    const { selectedCountry, imageApi,
      selectedCategory, announceTitle, announceDesc, announceDateEnd, announceDateStart
    } = this.state;
    if (announceTitle && imageApi && selectedCategory.length > 0 && announceDateEnd && announceDateStart) {

      const data = new FormData();
      data.append('post_title', announceTitle);
      data.append('post_content', announceDesc);
      data.append('announce_image', imageApi);
      data.append('category', selectedCategory);
      data.append('date_announce', announceDateEnd);
      data.append('end_announce', announceDateStart);
      data.append('blog_id', userData.blog_id?.userblog_id);

      if (this.props.location?.state?.editData) {
        AnnouncementService.updateEvent(data).then((result) => {
          result.data === 200 ? (
            ToastService.success(result.data.message),
            this.props.dismissModal()) :
            (ToastService.error(result.data.message));

        });
      }
      else {
        AnnouncementService.createAnnouncement(data).then((result) => {
          result.data === 200 ? (
            showLoading(false),
            ToastService.success(result.data.message),
            this.props.dismissModal()) :
            (showLoading(false), ToastService.error(result.data.message),
              window.history.back());
        });
      }
    }
    else {
      showLoading(false);
      return ToastService.error("Please fill required details");
    }

  };

  render() {
    const { categories,
      selectedCategory, announceTitle, announceDesc,
      imageApi, announceDateEnd, announceDateStart } = this.state;
    return (
      <div className="container pt-2">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Add Announcements</li>
          </ol>
        </nav> */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="head-title">
              <img src={announcementSvg} className="float-start me-3" alt="Announcements" /><h4 className="t0">Add New Announcements, <span className="linear-title t0">Ayush Australia</span></h4>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="row mt-3">
          <div className="col-12 mb-4">
            <p className="m-0 p-0"><b className="t2">Details about Announcements:</b></p>
            <p className="t2">You can fill out the basic details about the mission wide announcement and all the concerned practitioners of the announcement’s domain will get notified.</p>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-4 position-relative">
              <label htmlFor="announcementtitle" id="announcementtitle" className="form-label over-label t3">Announcement’s Title *</label>
              <input aria-labelledby="announcementtitle" type="text" className="form-control" placeholder="Enter announcement title here" name="evenannouncementtitle" value={announceTitle} onChange={(e) => this.setState({ announceTitle: e.target.value })} />
            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="announcementdetail" id="announcementdetail" className="form-label over-label t3">Brief Description </label>
              <textarea aria-labelledby="announcementdetail" className="form-control" rows="3" placeholder="Enter a brief description about the announcement here" value={announceDesc} onChange={(e) => this.setState({ announceDesc: e.target.value })}></textarea>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="announcementdate" id="announcementdate" className="form-label over-label t3">Date of Announcement *</label>
                  <input type="date" className="form-control inpbr" aria-labelledby="startdate"
                    value={moment(announceDateStart).format("yyyy-MM-DD")} min={moment(today).format("yyyy-MM-DD")}
                    onChange={(e) => this.setState({ announceDateStart: new Date(e.target.value) })} />
                </div >
              </div >
              <div className="col-md-6">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="announcementenddate" id="announcementenddate" className="form-label over-label t3">Valid Till *</label>
                  <input type="date" className="form-control inpbr" aria-labelledby="startdate"
                    value={moment(announceDateEnd).format("yyyy-MM-DD")} min={moment(today).format("yyyy-MM-DD")}
                    onChange={(e) => this.setState({ announceDateEnd: new Date(e.target.value) })} />
                </div>
              </div>
            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="eventname" id="domains" className="form-label t2"><b>Domains:</b></label>
              <div className="btn-group d-block event-check" role="group" aria-label="Basic checkbox toggle button group">
                {categories.map((item, index) =>
                  < span key={index}> <input aria-labelledby="domains" type="checkbox" className="btn-check" id={index} autoComplete="off" checked={selectedCategory.includes(item.name)} onClick={(e) => this.handleCategories(e.target.checked, item.name)} />
                    <label className="btn btn-outline-dark t2" htmlFor={index}>{item.name}</label></span>)}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="cliniclogo" id="cliniclogo" className="form-label t2"><b>Practitioner’s Clinic’s Logo*:</b></label>
            {/* <p>Practitioner’s Clinic’s Logo:</p> */}
            {imageApi ?
              <> <img src={imageApi.length > 0 ? imageApi : URL.createObjectURL(imageApi)} className="imgcon" />
                <div >
                  <button onClick={() => this.deleteImage()}><i className="fa fa-trash" aria-hidden="true"></i></button>
                </div></>
              :
              <div className="upload-drag d-flex align-items-center justify-content-center upbdr">
                <div className="uploadbox">
                  <img src={nofileSvg} className="d-block noimg " alt="upload" />
                  <span className="d-block">Upload Image by clicking </span>
                  <label htmlFor="productname" id="uploadimagg" className="bldlbl t2">Image of the Announcement *</label>
                  <input className="upload-btn" aria-labelledby="uploadimagg" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={(e) => this.onImageSelection(e)} />
                </div>
              </div>}
            <div className="col-12 p-3 mb-4">
              <div className="rw_">

                <div className="btrw">
                  <div className="text-end mob-btn-col">
                    <button type="button" className="btn adprdcard pd-tb-675em border-2 w-100" onClick={() => this.onAnnouncementCreateUpdate()}>Save</button>
                  </div>
                  <div className="mob-btn-col">
                    <button type="button" onClick={() => window.history.back()} className="btn theme-btn-outline pd-tb-675em border-2 w-100">Discard</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddAnnouncements;